package com.downdogapp.client

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import com.downdogapp.*
import com.downdogapp.client.widget.fadeIn
import com.downdogapp.client.widget.fadeOut
import org.w3c.dom.HTMLElement

actual interface View {

  val root: HTMLElement

  actual fun show()

  actual fun hide()

  actual fun fadeIn(duration: Duration, onComplete: View.() -> Unit)

  actual fun fadeOut(duration: Duration, onComplete: View.() -> Unit)

  actual var alpha: Double

  fun onBecameVisible() {}
  fun onResize() {}
  fun onMouseMove() {}
  fun onKeyPress(key: KeyStroke?) {}
}

actual abstract class AbstractView : View {

  actual override fun show() {
    root.show()
  }

  actual override fun hide() {
    root.hide()
  }

  actual override fun fadeIn(duration: Duration, onComplete: View.() -> Unit) {
    root.fadeIn(duration) {
      onComplete()
    }
  }

  actual override fun fadeOut(duration: Duration, onComplete: View.() -> Unit) {
    root.fadeOut(duration) {
      onComplete()
    }
  }

  actual override var alpha: Double
    get() = root.opacity ?: 1.0
    set(value) {
      root.opacity = value
    }
}

actual abstract class ComposeTopLevelView : AbstractView() {

  @Composable
  actual abstract fun BoxScope.Content()

  override val root: HTMLElement
    get() = throw UnsupportedOperationException("Not supported in JS")

  actual open fun onCoveredByViewController() {
    throw UnsupportedOperationException("Not supported in JS")
  }

  actual open fun onBeingRevealedByViewController() {
    throw UnsupportedOperationException("Not supported in JS")
  }
}
